import { Recipient } from "@models/bulkemailing/recipients";
import { UsersRepo } from "@services/users.repo";
import { EmailRepo } from "@services/email.repo";
import * as _ from 'lodash';

/** Wrapper so md-chips can track many files reliably (unique id per row). */
interface BulkEmailAttachmentEntry {
  id: number;
  file: File;
}

class CreateEmailController implements angular.IOnInit {
  public searchText = "";
  public emailTemplate = ""
  public emailSubject = ""
  /** All attachments for this send (multiple files supported; each chip maps to one entry). */
  public attachmentEntries: BulkEmailAttachmentEntry[] = [];
  public recipients: Recipient[] = []

  public availableRecipients: Recipient[] = [];
  public loadingRecipients: boolean = true;
  public sending: boolean = false;

  private nextAttachmentId = 0;

  /** Called from bulkEmailFilePicker when the user picks files (appended; supports multi-select in one dialog). */
  public setAttachmentFiles(files: FileList | null): void {
    if (!files || !files.length) {
      return;
    }
    const added = Array.from(files).map((file) => ({
      id: ++this.nextAttachmentId,
      file
    }));
    this.attachmentEntries = this.attachmentEntries.concat(added);
  }

  /** @ngInject */
  constructor(private $scope: angular.IScope, private $state: angular.ui.IStateService, private $mdDialog: angular.material.IDialogService,
    private usersRepo: UsersRepo, private emailRepo: EmailRepo, private notifyjs: any) {
  }

  $onInit(): void {
    this.loadingRecipients = true;
    this.usersRepo.getUserEmailGroups()
      .then(groups => {
        const recipientIndividuals = _.uniqBy(groups.reduce((prev, curr) => [...prev, ...curr.items], [])
          .map(i => (<Recipient>{
            name: i.name,
            type: 'Individual',
            addresses: [{
              userId: i.id,
              address: i.email,
              selected: true
            }]
          })), (i) => i.name )

        const recipientGroups = groups.map(g => (<Recipient>{
          name: g.groupName,
          type: 'Group',
          addresses: g.items.map(i => ({ userId: i.id, address: i.email, selected: true }))
        }))

        this.availableRecipients = [...recipientGroups, ...recipientIndividuals];
        this.loadingRecipients = false;
      })
      .catch((err) => {
        this.loadingRecipients = false;
        const errorMessage = (err.data && err.data.message) || err.data || err.message || 'Failed to load recipients. Please try again.';
        this.notifyjs(errorMessage, 'error');
      })
  }

  public selectedAddress(recipientGroup: Recipient) {
    return recipientGroup.addresses.filter(a => a.selected).length;
  }

  public filterRecipientOptions(filterText: string) {
    if (this.loadingRecipients) {
      return [];
    }
    const query = filterText.toLowerCase();
    return this.availableRecipients.filter(a => a.name.toLowerCase().includes(query));
  }

  public showGroupRecipients(recipientGroup: Recipient) {
    const dialogScope = this.$scope.$new() as any;
    dialogScope.groupAddresses = recipientGroup.addresses;

    this.$mdDialog.show({
      scope: dialogScope,
      template: '<md-dialog flex="30"><address-list-dialog addresses="groupAddresses"></address-list-dialog></md-dialog>'
    })

  }

  public sendEmail() {
    if (this.sending) {
      return;
    }

    this.sending = true;
    const formData = new FormData();
    formData.append('message', this.emailTemplate)
    formData.append('subject', this.emailSubject)

    this.attachmentEntries.forEach((entry) => formData.append('attachments', entry.file))

    this.recipients.map(recipient => {
      return _.uniq(recipient.addresses.filter(address => address.selected))
    }).forEach(group => {
      group.forEach(user => {
        formData.append('userids', user.userId.toString())
      })
    });

    this.emailRepo.sendGroupEmail(formData)
      .then(() => {
        this.notifyjs('Email sent successfully.', 'success');
        this.$state.go('^');
      })
      .catch((err) => {
        this.sending = false;
        const errorMessage = err.data || err.message || 'Failed to send email. Please try again.';
        this.notifyjs(errorMessage, 'error');
      });
  }

  public cancelEmail() {
    this.$state.go('^');
  }

  public getChipTitle = ($chip) => {
    if($chip && $chip.type === 'Individual'){
      return $chip.addresses[0].address
    }
  }
}

export const createEmail: angular.IComponentOptions = {
  controller: CreateEmailController,
  template: require('./createEmail.html')
}



// WEBPACK FOOTER //
// ./src/app/bulkemailing/views/createEmail.ts